// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SellerListPage_pageWrap__Wan54 {
  padding: 4px 4px 32px;
}

.SellerListPage_desktopTable__GxwOb {
  display: block;
}

.SellerListPage_mobileList__IjtlD {
  display: none;
}

@media (max-width: 767px) {
  .SellerListPage_desktopTable__GxwOb {
    display: none;
  }
  .SellerListPage_mobileList__IjtlD {
    display: block;
  }
}

/* =========================================================
   Toolbar
   ========================================================= */
.SellerListPage_toolbarRow__s5lMV {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.SellerListPage_searchInput__xVC0W {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 220px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.SellerListPage_searchInput__xVC0W:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.SellerListPage_filterSelect__6x1RN {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 170px;
  flex-shrink: 0;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.SellerListPage_filterSelect__6x1RN:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.SellerListPage_spacer__vKMZE {
  flex: 1 1;
}

.SellerListPage_ghostBtn__OLLK- {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F5F3FE;
  color: #4c2fb3;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}
.SellerListPage_ghostBtn__OLLK-:hover {
  background: #E7DEFB;
}

.SellerListPage_primaryBtn__R8gn8 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 18px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}
.SellerListPage_primaryBtn__R8gn8:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);
}

.SellerListPage_actionRow__c8Tv2 {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 24px 0;
}

/* =========================================================
   Status pills
   ========================================================= */
.SellerListPage_pillBase__iLYoo {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.SellerListPage_pillGreen__mzihE { background: #E9F9EF; color: #16A34A; }
.SellerListPage_pillRed__Eg0fa { background: #FDEDED; color: #DC2626; }
.SellerListPage_pillAmber__vI8Tm { background: #FDEEDD; color: #F7941D; }

.SellerListPage_loginPill__16R9s {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  background: #F5F3FE;
  color: #4c2fb3;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  border: none;
  transition: background 0.15s ease;
}
.SellerListPage_loginPill__16R9s:hover {
  background: #E7DEFB;
}

.SellerListPage_actionCell__sarvi {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* =========================================================
   Mobile card list
   ========================================================= */
.SellerListPage_mobileCard__6G8qw {
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 12px;
}

.SellerListPage_mobileRow__taNpa {
  display: flex;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.SellerListPage_mobileLabel__usgxc {
  min-width: 90px;
  flex-shrink: 0;
  color: #6B7280;
  font-weight: 600;
}

.SellerListPage_mobileValue__DCBtZ {
  color: #1F2430;
}

.SellerListPage_mobileActionRow__YOEpm {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

/* =========================================================
   Modal chrome (Import Sellers / detail views)
   ========================================================= */
.SellerListPage_modalHeader__Bq1rx {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
  border-radius: 12px 12px 0 0;
  margin: -16px -16px 16px;
}

.SellerListPage_modalTitle__L7Tgw {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.SellerListPage_modalLink__cPkYc {
  color: #ffffff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 13px;
}

.SellerListPage_modalClose__kbsLq {
  color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
}

.SellerListPage_detailSectionTitle__2t9N9 {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #4c2fb3;
  margin: 18px 0 10px;
}
.SellerListPage_detailSectionTitle__2t9N9:first-child {
  margin-top: 0;
}

/* =========================================================
   Legacy "check live" detail modal — restyle the raw
   hardcoded tables via descendant selectors instead of
   touching every row.
   ========================================================= */
.SellerListPage_legacyDetailWrap__0N1X9 h2 {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 15px !important;
  font-weight: 700 !important;
  color: #4c2fb3 !important;
  margin: 18px 0 10px !important;
}
.SellerListPage_legacyDetailWrap__0N1X9 h2:first-child {
  margin-top: 0 !important;
}
.SellerListPage_legacyDetailWrap__0N1X9 table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
  border: 1px solid #E7E9F1 !important;
  border-radius: 10px !important;
  overflow: hidden !important;
}
.SellerListPage_legacyDetailWrap__0N1X9 th {
  background: #F5F3FE !important;
  color: #4c2fb3 !important;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-size: 11.5px !important;
  font-weight: 700 !important;
  border-color: #E7E9F1 !important;
}
.SellerListPage_legacyDetailWrap__0N1X9 td {
  border-color: #F1F2F6 !important;
  font-size: 13px;
  color: #374151;
}
.SellerListPage_legacyDetailWrap__0N1X9 tr:first-child td {
  border-top: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/sellerlist/SellerListPage.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;EAC9C,uDAAuD;EACvD,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,oBAAoB;AACtB;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,mCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,iCAAW,mBAAmB,EAAE,cAAc,EAAE;AAChD,mCAAa,mBAAmB,EAAE,cAAc,EAAE;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;;;;8DAI8D;AAC9D;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.desktopTable {\n  display: block;\n}\n\n.mobileList {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .desktopTable {\n    display: none;\n  }\n  .mobileList {\n    display: block;\n  }\n}\n\n/* =========================================================\n   Toolbar\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.searchInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 220px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.searchInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.filterSelect {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 170px;\n  flex-shrink: 0;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.filterSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.spacer {\n  flex: 1;\n}\n\n.ghostBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 16px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n.ghostBtn:hover {\n  background: #E7DEFB;\n}\n\n.primaryBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 18px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n.primaryBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);\n}\n\n.actionRow {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 12px 24px 0;\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n.pillAmber { background: #FDEEDD; color: #F7941D; }\n\n.loginPill {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 20px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  border: none;\n  transition: background 0.15s ease;\n}\n.loginPill:hover {\n  background: #E7DEFB;\n}\n\n.actionCell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.mobileRow {\n  display: flex;\n  gap: 12px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mobileLabel {\n  min-width: 90px;\n  flex-shrink: 0;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.mobileValue {\n  color: #1F2430;\n}\n\n.mobileActionRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n/* =========================================================\n   Modal chrome (Import Sellers / detail views)\n   ========================================================= */\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n  border-radius: 12px 12px 0 0;\n  margin: -16px -16px 16px;\n}\n\n.modalTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.modalLink {\n  color: #ffffff;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.modalClose {\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n}\n\n.detailSectionTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #4c2fb3;\n  margin: 18px 0 10px;\n}\n.detailSectionTitle:first-child {\n  margin-top: 0;\n}\n\n/* =========================================================\n   Legacy \"check live\" detail modal — restyle the raw\n   hardcoded tables via descendant selectors instead of\n   touching every row.\n   ========================================================= */\n.legacyDetailWrap h2 {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  color: #4c2fb3 !important;\n  margin: 18px 0 10px !important;\n}\n.legacyDetailWrap h2:first-child {\n  margin-top: 0 !important;\n}\n.legacyDetailWrap table {\n  border-collapse: separate !important;\n  border-spacing: 0 !important;\n  border: 1px solid #E7E9F1 !important;\n  border-radius: 10px !important;\n  overflow: hidden !important;\n}\n.legacyDetailWrap th {\n  background: #F5F3FE !important;\n  color: #4c2fb3 !important;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  font-size: 11.5px !important;\n  font-weight: 700 !important;\n  border-color: #E7E9F1 !important;\n}\n.legacyDetailWrap td {\n  border-color: #F1F2F6 !important;\n  font-size: 13px;\n  color: #374151;\n}\n.legacyDetailWrap tr:first-child td {\n  border-top: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `SellerListPage_pageWrap__Wan54`,
	"desktopTable": `SellerListPage_desktopTable__GxwOb`,
	"mobileList": `SellerListPage_mobileList__IjtlD`,
	"toolbarRow": `SellerListPage_toolbarRow__s5lMV`,
	"searchInput": `SellerListPage_searchInput__xVC0W`,
	"filterSelect": `SellerListPage_filterSelect__6x1RN`,
	"spacer": `SellerListPage_spacer__vKMZE`,
	"ghostBtn": `SellerListPage_ghostBtn__OLLK-`,
	"primaryBtn": `SellerListPage_primaryBtn__R8gn8`,
	"actionRow": `SellerListPage_actionRow__c8Tv2`,
	"pillBase": `SellerListPage_pillBase__iLYoo`,
	"pillGreen": `SellerListPage_pillGreen__mzihE`,
	"pillRed": `SellerListPage_pillRed__Eg0fa`,
	"pillAmber": `SellerListPage_pillAmber__vI8Tm`,
	"loginPill": `SellerListPage_loginPill__16R9s`,
	"actionCell": `SellerListPage_actionCell__sarvi`,
	"mobileCard": `SellerListPage_mobileCard__6G8qw`,
	"mobileRow": `SellerListPage_mobileRow__taNpa`,
	"mobileLabel": `SellerListPage_mobileLabel__usgxc`,
	"mobileValue": `SellerListPage_mobileValue__DCBtZ`,
	"mobileActionRow": `SellerListPage_mobileActionRow__YOEpm`,
	"modalHeader": `SellerListPage_modalHeader__Bq1rx`,
	"modalTitle": `SellerListPage_modalTitle__L7Tgw`,
	"modalLink": `SellerListPage_modalLink__cPkYc`,
	"modalClose": `SellerListPage_modalClose__kbsLq`,
	"detailSectionTitle": `SellerListPage_detailSectionTitle__2t9N9`,
	"legacyDetailWrap": `SellerListPage_legacyDetailWrap__0N1X9`
};
export default ___CSS_LOADER_EXPORT___;
